import { Box, Button, Popover, MenuItem, Typography, StraightenIcon } from 'src/components';
import { useState } from 'react';
import { DISTANCE_OPTIONS } from 'src/data';

export default function DistancePicker({ distanceUnit, setDistanceUnit }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const open = Boolean(anchorEl);

  const handleSelect = (val) => {
    setDistanceUnit(val);
    handleClose();
  };

  return (
    <>
        <Button 
            variant="text"
            disableRipple
            onClick={handleClick} 
            sx={{ borderRadius: 2, flexDirection: 'row', p: 1, gap: 1 }}>
            <StraightenIcon />
            <Typography variant="body2" fontWeight={600}>Distance</Typography>
        </Button>

        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
            transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            sx={{ mt: 1 }}
        >
            <Box px={0.5} py={1}>
            {DISTANCE_OPTIONS.map((option) => (
                <MenuItem
                key={option.value}
                selected={distanceUnit === option.value}
                onClick={() => handleSelect(option.value)}
                dense
                >
                <Typography variant="body2" fontWeight={600}>{option.label}</Typography>
                </MenuItem>
            ))}
            </Box>
        </Popover>
    </>
  );
}
